import { EntityCombobox } from "@/components/EntityCombobox";

export interface OpcaoLista {
  id: number;
  descricao: string;
  /** Código exibido antes da descrição (ex.: "1.1.01.001"). */
  codigo?: string | number | null;
  extra?: string | null;
}

interface ListaSearchComboboxProps {
  /** Lista já carregada pela tela (cadastros curtos/médios: centro de custo, grupo, plano de contas…). */
  opcoes: OpcaoLista[];
  value?: number | null;
  onChange: (id: number | null) => void;
  /** Distingue o cache entre listas diferentes na mesma tela. */
  chave: string;
  placeholder?: string;
  permitirLimpar?: boolean;
  disabled?: boolean;
  className?: string;
}

const normalizar = (s: string) => s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

/**
 * Combobox com busca (código ou descrição) sobre uma lista JÁ carregada — o substituto do
 * `<Select>` gigante sem busca. Para cadastros grandes, prefira um `*SearchCombobox` server-side.
 */
export function ListaSearchCombobox({
  opcoes, value, onChange, chave, placeholder = "Selecione...", permitirLimpar = true, disabled, className,
}: ListaSearchComboboxProps) {
  const atual = value ? opcoes.find((o) => o.id === value) ?? null : null;
  return (
    <EntityCombobox<OpcaoLista>
      value={value ?? null}
      onChange={onChange}
      itemInicial={atual}
      queryKey={`lista-${chave}-${opcoes.length}`}
      buscar={async (termo) => {
        const t = normalizar(termo);
        const filtradas = t
          ? opcoes.filter((o) => normalizar(`${o.codigo ?? ""} ${o.descricao}`).includes(t))
          : opcoes;
        return filtradas.slice(0, 100);
      }}
      getId={(o) => o.id}
      getCodigo={(o) => o.codigo}
      getDescricao={(o) => o.descricao}
      getExtra={(o) => o.extra}
      debounceMs={0}
      placeholder={placeholder}
      placeholderBusca="Buscar por código ou descrição..."
      permitirLimpar={permitirLimpar}
      disabled={disabled}
      className={className}
    />
  );
}
